import { useMutation } from '@tanstack/react-query';

import { ZonePricingPlan } from 'src/features/zone/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/zone-pricing-plan/`;

type MutationFnType = typeof mutationFn;
interface DTO {
    zone: string;
    parkingId: string;
}

const mutationFn = ({ parkingId, ...data }: DTO): Promise<ZonePricingPlan> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateZonePricingPlan };
